export default "__VITE_ASSET__DoquPueB__"